/**
 * №53 (53.0) — the workspace switch, shared by the two surfaces that offer one.
 *
 * Lifted out of `WorkspaceSwitcher.tsx` so the rail-foot profile menu
 * (`ShellProfileMenu`, D-CR14) RE-SKINS this switcher rather than rebuilding it.
 * Its own file because eslint's `react-refresh/only-export-components` is right:
 * a component module that also exports a plain function breaks fast refresh, and
 * a shared helper is not a component.
 *
 * The toast is the part worth sharing. That connected Claude Code and Cursor
 * sessions do NOT follow you to the new workspace is non-obvious, was got right
 * once, and is exactly the kind of thing a second implementation quietly drops.
 * It fires once per browser session, not once per switch — a warning repeated on
 * every switch is a warning nobody reads.
 *
 * Navigation stays with the CALLER: the two surfaces land in different places
 * (`/app` vs the maker root) and this helper has no opinion about routes.
 */
import { switchWorkspace, getUser } from "../../../lib/auth";
import { showToast } from "../primitives";

/**
 * Switch workspace, warning once per session that connected MCP clients do not
 * follow.
 *
 * Extracted so the rail-foot profile menu (`ShellProfileMenu`, D-CR14) re-skins
 * this switcher rather than rebuilding it. The toast is the part worth sharing:
 * that Claude Code and Cursor sessions stay on their previous workspace is
 * non-obvious, was got right once, and is exactly the kind of thing a second
 * implementation quietly drops. Navigation stays with the CALLER — the two
 * surfaces land in different places, and this helper has no opinion about routes.
 *
 * A plain function, not a hook: `switchWorkspace` and `getUser` are module-level
 * in `lib/auth`, so nothing here needs React.
 */
export async function switchWorkspaceWithHint(id: string): Promise<boolean> {
  const ok = await switchWorkspace(id);
  if (ok) {
    const hintKey = "kuvio_ws_switch_hint_shown";
    if (!sessionStorage.getItem(hintKey)) {
      sessionStorage.setItem(hintKey, "1");
      const target = getUser()?.workspaces.find((ws) => ws.id === id);
      showToast(
        `Switched to ${target?.name ?? "workspace"}. Your Claude Code and Cursor MCP sessions stay on their previous workspace — use the "switch workspace" command from your MCP client to follow.`,
        "success",
        true,
      );
    }
  }
  return ok;
}
